<template>
  <div class="cards-section__block" :class="NamedBlockClass">
    <div class="cards-section__block-wrapper">
      <slot v-if="named" name="block-name" />
      <AppGrid>
        <slot />
      </AppGrid>
    </div>
  </div>
</template>

<script>
//Components
import AppGrid from 'Ui/AppGrid'

export default {
  name: 'CardsSectionBlock',

  props: {
    named: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    AppGrid,
  },

  computed: {
    NamedBlockClass() {
      return this.named && 'cards-section__block--named'
    },
  },
}
</script>

<style scoped>
.cards-section__block {
  position: relative;
}

.cards-section__block-wrapper {
  margin-top: 20px;
}

.cards-section__block--named .cards-section__block-wrapper {
  margin-top: 40px;
  border-radius: 14px;
  border: 2px solid var(--c-secondary-400);
}
</style>
